// Work Page for Portfolio
// Work Section ->
//  Work Description

import React from 'react';

 const WorkPage = () => {
    return (
        <div>
            Work Page
        </div>
    )
}

export default WorkPage